<template>
  <div>
    <FiltroAreaAcao
      v-model="drawer"
      :podeEditar="podeEditar"
      :pilares="opcoesPilar"
      :pilarSelecionado="pilarSelecionado"
      @filtrar-area-acao="(f) => aplicarFiltro(f)"
      @clear="limparFiltro"
      @pilar-selecionado="(p) => (pilarSelecionado = p)"
    />

    <v-row no-gutters justify="end" align="center" class="mt-6 mr-6 mb-4">
      <v-col cols="auto">
        <button-cadu @click="drawer = true">FILTRAR</button-cadu>
      </v-col>
      <v-col class="ml-4" cols="auto" @click="download">
        <icon name="download" :size="20" style="cursor: pointer;" tooltip="Exportar" />
      </v-col>
      <v-col class="ml-4" cols="auto" @click="anexar" v-if="podeEditar">
        <icon name="paperclip" :size="20" style="cursor: pointer;" tooltip="Anexar Documento" />
      </v-col>
      <v-col class="ml-4" cols="auto" @click="abrirModalAdicionarMunicipio" v-if="podeEditar">
        <icon name="plus-circle" :size="20" style="cursor: pointer;" tooltip="Adicionar Município" />
      </v-col>
    </v-row>

    <TabelaAreaAcaoPilar
      :municipios="municipiosFiltrados"
      :textos="textosExplicativos"
      :podeEditar="podeEditar"
      :isAdminBrasil="isAdminBrasil"
      :loading="carregando"
      @alterarPilar="onAlterarPilar"
      @abrirInfoComplementar="onAbrirInfoComplementar"
      @salvarTexto="onSalvarTexto"
    />

    <!-- Modal adicionar município (reaproveitado) -->
    <ModalAreaAcao v-model="showModalAdicionar" @add-municipio="onAdicionarMunicipio" @close="showModalAdicionar = false" />

    <!-- Modal informações complementares -->
    <ModalInfoComplementar
      v-if="showModalInfo"
      v-model="showModalInfo"
      :municipio="municipioSelecionado"
      :podeEditar="isAdminBrasil"
      :service="areaAcaoService"
    />

    <overlay-loading v-model="loadingOverlay" />

    <SucessoModal
      :showSucess="showSucesso"
      :sucessType="'generic'"
      :genericTitle="'Sucesso!'"
      :genericMessage="mensagemSucesso"
      @close="showSucesso = false"
    />

    <ErrorModal v-model="showErro" :errObj="errObj" />
  </div>
</template>

<script>
import jwtDecode from 'jwt-decode'
import { EventBus } from '@/services/EventBus/EventBus'
import AreaAcaoService from '@/services/AreaAcao/AreaAcao'
import TabelaAreaAcaoPilar from './Shared/TabelaAreaAcaoPilar'
import ModalInfoComplementar from './Shared/ModalInfoComplementar'
import ModalAreaAcao from './Shared/ModalAreaAcao'
import FiltroAreaAcao from './Shared/FiltroAreaAcao'
import ErrorModal from '@/components/Shared/ErrorModal/ErrorModal'

const PILARES = ['ESTATUTARIA', 'COMERCIAL', 'COOPERATIVISMO', 'CREDENCIAMENTO']
const PILAR_LABELS = {
  ESTATUTARIA: 'Estatutária',
  COMERCIAL: 'Comercial',
  COOPERATIVISMO: 'Cooperativismo',
  CREDENCIAMENTO: 'Credenciamento'
}

export default {
  components: { TabelaAreaAcaoPilar, ModalInfoComplementar, ModalAreaAcao, FiltroAreaAcao, ErrorModal },
  data() {
    return {
      municipios: [],
      municipiosFiltrados: [],
      textosExplicativos: {},
      carregando: false,
      loadingOverlay: false,
      drawer: false,
      showModalAdicionar: false,
      showModalInfo: false,
      municipioSelecionado: null,
      pilarSelecionado: '',
      opcoesPilar: PILARES.map((k) => ({ key: k, label: PILAR_LABELS[k] })),
      showSucesso: false,
      mensagemSucesso: '',
      showErro: false,
      errObj: {},
      role: '',
      areaAcaoService: null,
      filtroAtivo: {}
    }
  },
  computed: {
    podeEditar() {
      return JSON.parse(localStorage.getItem('optionEdit')) &&
        (this.role === 'admin_brasil' || this.role === 'dirigente')
    },
    isAdminBrasil() {
      return this.role === 'admin_brasil'
    }
  },
  async beforeMount() {
    const token = localStorage.getItem('tokenBearer')
    const decoded = jwtDecode(token)
    this.role = decoded.role
    this.areaAcaoService = new AreaAcaoService(token, this.$appConfig.config.API, this.$idUnimed)
    await Promise.all([this.carregarMunicipios(), this.carregarTextos()])
  },
  methods: {
    async carregarMunicipios() {
      this.carregando = true
      try {
        const res = await this.areaAcaoService.getMunicipiosComPilares()
        this.municipios = res.data
        this.municipiosFiltrados = this.municipios
      } catch (err) {
        this.showErro = true
        this.errObj = { status: err?.response?.status, error: err?.response?.data?.message }
      } finally {
        this.carregando = false
      }
    },
    async carregarTextos() {
      try {
        const res = await this.areaAcaoService.getTextosExplicativos()
        this.textosExplicativos = Object.fromEntries(res.data.map((t) => [t.pilar.toLowerCase(), t.descricao]))
      } catch {
        // sem texto — usa label padrão
      }
    },
    async onAlterarPilar({ municipio, pilar, valor }) {
      this.loadingOverlay = true
      try {
        if (valor) {
          await this.areaAcaoService.postMunicipiosPilar(pilar.toUpperCase(), [municipio.id])
        } else {
          await this.areaAcaoService.deleteMunicipiosPilar(pilar.toUpperCase(), [municipio.id])
        }
        // Atualiza localmente para feedback imediato
        const idx = this.municipios.findIndex((m) => m.id === municipio.id)
        if (idx !== -1) this.municipios[idx][pilar] = valor
        this.municipiosFiltrados = [...this.municipios]
        this.mensagemSucesso = `Município ${valor ? 'adicionado ao' : 'removido do'} pilar ${PILAR_LABELS[pilar.toUpperCase()]} com sucesso!`
        this.showSucesso = true
      } catch (err) {
        this.showErro = true
        this.errObj = { status: err?.response?.status, error: err?.response?.data?.message }
        await this.carregarMunicipios()
      } finally {
        this.loadingOverlay = false
      }
    },
    onAbrirInfoComplementar(municipio) {
      this.municipioSelecionado = municipio
      this.showModalInfo = true
    },
    abrirModalAdicionarMunicipio() {
      this.showModalAdicionar = true
    },
    anexar() {
      EventBus.$emit('showAnexo', 'Área de Ação')
    },
    async onAdicionarMunicipio(selecionados) {
      const ids = selecionados.map((m) => m.id)
      const pilarAlvo = this.pilarSelecionado || 'ESTATUTARIA'
      this.loadingOverlay = true
      try {
        await this.areaAcaoService.postMunicipiosPilar(pilarAlvo, ids)
        await this.carregarMunicipios()
        this.mensagemSucesso = `Município(s) adicionado(s) ao pilar ${PILAR_LABELS[pilarAlvo]} com sucesso!`
        this.showSucesso = true
      } catch (err) {
        this.showErro = true
        this.errObj = { status: err?.response?.status, error: err?.response?.data?.message }
      } finally {
        this.loadingOverlay = false
      }
    },
    async onSalvarTexto({ pilar, descricao }) {
      try {
        await this.areaAcaoService.putTextoExplicativo(pilar.toUpperCase(), descricao)
        this.textosExplicativos = { ...this.textosExplicativos, [pilar]: descricao }
        this.mensagemSucesso = 'Texto explicativo atualizado!'
        this.showSucesso = true
      } catch (err) {
        this.showErro = true
        this.errObj = { status: err?.response?.status, error: err?.response?.data?.message }
      }
    },
    aplicarFiltro(filtro) {
      this.filtroAtivo = filtro
      const nome = filtro.municipio ? filtro.municipio.toLowerCase() : ''
      const uf = filtro.uf ? filtro.uf.sigla : ''
      const codigo = filtro.codigo ? String(filtro.codigo) : ''
      const pilar = filtro.pilar ? filtro.pilar.toLowerCase() : ''
      this.municipiosFiltrados = this.municipios.filter((m) => {
        return (
          (!nome || m.nome.toLowerCase().includes(nome)) &&
          (!uf || m.sigla === uf) &&
          (!codigo || String(m.id).includes(codigo)) &&
          (!pilar || m[pilar])
        )
      })
    },
    limparFiltro() {
      this.filtroAtivo = {}
      this.municipiosFiltrados = this.municipios
    },
    async download() {
      this.loadingOverlay = true
      try {
        const res = await this.areaAcaoService.exportar('')
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'area_acao.xlsx')
        document.body.appendChild(link)
        link.click()
        link.remove()
      } finally {
        this.loadingOverlay = false
      }
    }
  }
}
</script>
